/* global Swiper */
import router from '../router';
import helpers from '../helpers';
import parallax from './parallax';
import {Navigation} from 'swiper';
// import interact from 'interactjs';

Swiper.use([Navigation]);

const $grid = document.querySelector('.grid');
const $gridTooltip = document.querySelector('.grid__tooltip');

// let freeze;
// let scaleCards;
let draggable;
let gridSlider;
let isFirst = true;
// let gridWidth;
// let gridHeight;
// let startTransformX;
let gridHeight = $grid.offsetHeight;
let gridWidth = $grid.offsetWidth;
let startTransformX = -1 * (gridWidth / 2 - window.innerWidth / 2);
let startTransformY = -1 * (gridHeight / 2 - window.innerHeight / 2);
let translateX = startTransformX;
let translateY = startTransformY;
let canTransform = false;
let gridStart = null;
let moveGrid = null;
let gridTransition = null;

const vw = (value) => {
	const base = 1366;
	const result = value / base * 100;

	return parseFloat(result) / 100 * (/vh/gi.test(result) ? window.innerHeight : window.innerWidth);
};

function hideTooltip() {
	if ($gridTooltip.classList.contains('is-hidden')) {
		return;
	}

	gsap.to($gridTooltip, {
		onComplete() {
			$gridTooltip.classList.add('is-hidden');
		},
		autoAlpha: 0,
		clearProps: 'all',
	});
}

function setGridPosition(x = startTransformX, time = 0) {
	if (helpers.isMobile()) {
		return;
	}

	// if (vars.isEdgeIE) {
	// 	$grid.style.top = `${startTransformY}px`;
	// 	$grid.style.left = `${startTransformX}px`;
	// 	$grid.style.transform = 'rotate(-0.0001deg)';
	// } else {
	// 	$grid.style.transform = `translate3d(${0}px, ${-vw(182)}px, 0) rotate(0.0001deg)`;
	// }
	gsap.to($grid, {
		translateX: x,
		translateY: -vw(182),
		rotate: '0.0001deg',
		duration: time,
	});
}

function dragStart() {
	$grid.classList.add('is-dragging');
	$grid.classList.add('is-drag');

	hideTooltip();
}

function dragEnd(e) {
	$grid.classList.remove('is-dragging');
	// $grid.classList.remove('is-drag');

	parallax.enabled();

	gsap.to(['.grid-item--product', '.grid-item--person'], {
		scale: 1,
		rotation: '+=0.0001',
	});
	$grid.classList.remove('is-drag');
}

function dragPress() {
	if ($grid.classList.contains('is-item-hovered')) {
		return;
	}

	$grid.classList.add('is-drag');
	$grid.classList.add('is-dragging');

	parallax.disabled();
	// gsap.to(['.grid-item--product', '.grid-item--person'], {
	// 	delay: 0.1,
	// 	scale: 0.9,
	// });
}

function dragRelease() {
	if ($grid.classList.contains('is-item-hovered')) {
		// return;
	}
	// gsap.to(['.grid-item--product', '.grid-item--person'], {
	// 	scale: 1,
	// 	onComplete() {
	// 		setTimeout(() => {
	// 			$grid.classList.remove('is-drag');
	// 		}, 100);
	// 	},
	// });
}

function initDraggable() {
	$grid.style.transform = `translate3d(${translateX}, ${translateY}px, 0) rotate(0.0001deg)`;
}

function initSwiper() {
	let swiperOptions = {
		loop: true,
		loopedSlides: 5,
		speed: 1000,
		grabCursor: true,
		centeredSlides: true,
		slidesPerView: 'auto',
		slideClass: 'grid-item',
		wrapperClass: 'grid__row',
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	};

	document.querySelector('.grid__container').classList.add('swiper-container');
	gridSlider = new Swiper('.grid__container', swiperOptions);
}

function resize() {
	gridWidth = $grid.offsetWidth;
	gridHeight = $grid.offsetHeight;
	startTransformX = -1 * (gridWidth / 2 - window.innerWidth / 2);
	startTransformY = -1 * (gridHeight / 2 - window.innerHeight / 2);

	if ($grid.classList.contains('is-hidden')) {
		return;
	}

	if (helpers.isMobile()) {
		if (draggable) {
			draggable.unset();
			draggable = false;
		}

		gsap.set($grid, {
			clearProps: 'all',
		});

		if (!gridSlider) {
			initSwiper();
		}
	} else {
		setGridPosition(startTransformX, 0.5);

		setTimeout(() => {
			if (draggable) {
				draggable.update(true, true);
			} else {
				initDraggable();
			}

			if (gridSlider) {
				gridSlider.destroy(true, true);
				gridSlider = false;
				document.querySelector('.grid__container').classList.remove('swiper-container');
			}
		}, 100);
	}
}

function init(isModal = false) {
	if (!$grid) {
		return;
	}

	if (helpers.isMobile()) {
		initSwiper();

		return;
	}

	gridWidth = $grid.offsetWidth;
	gridHeight = $grid.offsetHeight;
	startTransformX = -1 * (gridWidth / 2 - window.innerWidth / 2);

	if (!isModal) {
		parallax.init();
	}

	if (!draggable) {
		initDraggable();
	}
}

function leftButtonPressed(e) {
	return e.which === 1;
}

function transformGrid() {
	moveGrid = setInterval(() => {
		$grid.style.transform = `translate3d(${translateX}px, ${translateY}px, 0) rotate(0.0001deg)`;
	}, 0);
}

function eventListener() {
	if (!helpers.isMobile()) {
		$grid.addEventListener('mouseover', (e) => {
			// if (e.target.iclassList.contains('.intro__item-content-link')) {
			// gridTransition = false;
			// }
		});
		$grid.addEventListener('mouseout', (e) => {
			// if (e.target.classList.contains('.intro__item-content-link')) {
			// gridTransition = true;
			// }
		});
		$grid.addEventListener('mousedown', (event) => {
			if (leftButtonPressed(event)) {
				dragPress();
				// setGridItemZ();
				// vars.$intro.addClass('is-dragging');
				// vars.$html.addClass('grid-dragging');
				canTransform = true;

				if (isFirst) {
					translateX = -1 * ($grid.offsetWidth / 2 - window.innerWidth / 2);
					translateY = -vw(182);
					isFirst = false;
				}

				gridStart = {
					e: event,
					translateX,
					translateY,
				};
			}
		});

		$grid.addEventListener('touchstart', (event) => {
			dragPress();
			// setGridItemZ();
			// vars.$intro.addClass('is-dragging');
			// vars.$html.addClass('grid-dragging');
			canTransform = true;

			if (isFirst) {
				translateX = -1 * ($grid.offsetWidth / 2 - window.innerWidth / 2);
				translateY = -vw(182);
				isFirst = false;
			}

			gridStart = {
				e: event,
				translateX,
				translateY,
			};
		});
		$grid.addEventListener('mousemove', (e) => {
			clearInterval(moveGrid);

			if (canTransform && leftButtonPressed(e)) {
				dragStart();
				dragRelease();
				// animation.stopGrabCursor();

				let x = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX) -
					(gridStart.e.changedTouches ? gridStart.e.changedTouches[0].clientX : gridStart.e.clientX);

				let y = (e.changedTouches ? e.changedTouches[0].clientY : e.clientY) -
					(gridStart.e.changedTouches ? gridStart.e.changedTouches[0].clientY : gridStart.e.clientY);

				translateX = gridStart.translateX + x;
				translateY = gridStart.translateY + y;

				if (translateX >= 0) {
					translateX = 0;
				}
				if (-translateX >= gridWidth - innerWidth) {
					translateX = -(gridWidth - innerWidth);
				}
				if (translateY >= 0) {
					translateY = 0;
				}
				if (-translateY >= gridHeight - innerHeight) {
					translateY = -(gridHeight - innerHeight);
				}

				transformGrid();
			} else {
				// clearGridItemZ();
				// vars.$intro.removeClass('is-dragging');
				// vars.$html.removeClass('grid-dragging');
			}
		});
		$grid.addEventListener('touchmove', (e) => {
			clearInterval(moveGrid);

			if (canTransform) {
				dragStart();
				dragRelease();
				// animation.stopGrabCursor();

				let x = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX) -
					(gridStart.e.changedTouches ? gridStart.e.changedTouches[0].clientX : gridStart.e.clientX);

				let y = (e.changedTouches ? e.changedTouches[0].clientY : e.clientY) -
					(gridStart.e.changedTouches ? gridStart.e.changedTouches[0].clientY : gridStart.e.clientY);

				translateX = gridStart.translateX + x;
				translateY = gridStart.translateY + y;

				if (translateX >= 100) {
					translateX = 0;
				}
				if (-translateX >= gridWidth - innerWidth) {
					translateX = -(gridWidth - innerWidth);
				}
				if (translateY >= 100) {
					translateY = 0;
				}
				if (-translateY >= gridHeight - innerHeight) {
					translateY = -(gridHeight - innerHeight);
				}

				transformGrid();
			} else {
				// clearGridItemZ();
				// vars.$intro.removeClass('is-dragging');
				// vars.$html.removeClass('grid-dragging');
			}
		});
		$grid.addEventListener('mouseup', (e) => {
			e.preventDefault();
			canTransform = false;
			dragEnd();
			// clearGridItemZ();

			// vars.$intro.removeClass('is-dragging');
			// vars.$html.removeClass('grid-dragging');
			// vars.$intro.find('.intro__item').removeClass('is-dragging');
		});

		$grid.addEventListener('touchend', (e) => {
			e.preventDefault();
			canTransform = false;
			dragEnd();
			// clearGridItemZ();

			// vars.$intro.removeClass('is-dragging');
			// vars.$html.removeClass('grid-dragging');
			// vars.$intro.find('.intro__item').removeClass('is-dragging');
		});
	}
	const gridItems = document.querySelectorAll('.grid-item');
	Array.prototype.forEach.call(gridItems, (item) => {
		item.addEventListener('click', (e) => {
			e.preventDefault();

			e.currentTarget.classList.add('is-active');

			const url = e.currentTarget.getAttribute('data-href');
			helpers.dispatcher.trigger('cards-click', {name: e.currentTarget.querySelector('.grid-item__content-name').textContent});
			$grid.classList.add('is-modal-opened');

			router.navigate(url);
		});

		item.addEventListener('mouseenter', (e) => {
			if (helpers.isMobile()) {
				return;
			}

			if (draggable) {
				draggable.enabled = false;
			}
			Array.prototype.forEach.call(gridItems, (el) => {
				if (el !== item) {
					gsap.to(el, {
						scale: 0.9,
					});
				}
			});

			e.currentTarget.classList.add('is-hovered');
			// $grid.classList.add('is-item-hovered');
		}, false);

		item.addEventListener('mouseleave', (e) => {
			if (helpers.isMobile()) {
				return;
			}
			// if (draggable) {
			// 	draggable.enabled = true;
			// }

			Array.prototype.forEach.call(gridItems, (el) => {
				if (el !== item) {
					gsap.to(el, {
						scale: 1,
					});
				}
			});

			e.currentTarget.classList.remove(...['is-hovered', 'dragend-hovered']);
			$grid.classList.remove('is-item-hovered');

			// e.currentTarget.classList.remove('is-hovered');
			// $grid.classList.remove('is-item-hovered');
		}, false);
	});

	window.addEventListener('resize', resize, false);
}

function destroy() {
	isFirst = true;

	draggable.unset();
	parallax.destroyed();

	window.removeEventListener('resize', resize, false);

	const gridItems = document.querySelectorAll('.grid-item');
	Array.prototype.forEach.call(gridItems, (item) => {
		item.removeEventListener('mouseenter', (e) => {
			e.currentTarget.classList.add('is-hovered');
			// $grid.classList.add('is-item-hovered');
		}, false);

		item.removeEventListener('mouseleave', (e) => {
			e.currentTarget.classList.remove('is-hovered');
			// $grid.classList.remove('is-item-hovered');
		}, false);
	});
}

export default {
	init,
	destroy,
	eventListener,
	setGridPosition,
};
